// Servicio para programar tareas periódicas
import { checkPendingApprovals, checkPendingSignatures } from './approvalService';

let approvalCheckInterval = null;

/**
 * Inicia el servicio de verificación de actas pendientes
 * @param {number} intervalMinutes - Intervalo en minutos para verificar (por defecto 1 minuto)
 */
export const startApprovalCheckService = (intervalMinutes = 1) => {
  // Detener cualquier intervalo existente
  if (approvalCheckInterval) {
    clearInterval(approvalCheckInterval);
  }
  
  
  // Ejecutar inmediatamente la primera verificación
  checkPendingApprovals().catch(error => {
    console.error('Error en verificación inicial de actas pendientes:', error);
  });
  
  checkPendingSignatures().catch(error => {
    console.error('Error en verificación inicial de firmas pendientes:', error);
  });
  
  // Programar verificaciones periódicas
  approvalCheckInterval = setInterval(() => {
    checkPendingApprovals().catch(error => {
      console.error('Error en verificación periódica de actas pendientes:', error);
    });
    
    checkPendingSignatures().catch(error => {
      console.error('Error en verificación periódica de firmas pendientes:', error);
    });
  }, intervalMinutes * 60 * 1000);
  
  return true;
};

/**
 * Detiene el servicio de verificación de actas pendientes
 */
export const stopApprovalCheckService = () => {
  if (approvalCheckInterval) {
    clearInterval(approvalCheckInterval);
    approvalCheckInterval = null;
    return true;
  }
  return false;
};
